import { Navigate, Outlet } from 'react-router-dom';
import { PROFILE_TYPE } from '../../helper/globalConstant';

const canRouteToAdmin = new Set([
  PROFILE_TYPE.SUPER_ADMIN,
  PROFILE_TYPE.DISTRIBUTOR,
  PROFILE_TYPE.INTEGRATOR,
]);

const AdminGuard = () => {
  const sess_user_data = localStorage.getItem('sess_user');

  if (sess_user_data) {
    const sess_user = JSON.parse(sess_user_data);
    const priority = sess_user?.userProfile?.priority;

    if (canRouteToAdmin.has(priority)) return <Outlet />;

    return <Navigate to="/customer/overview" replace />;

  }

  return <Navigate to="/login" replace />;
};

export default AdminGuard;
